import { SET_CATEGORY_INFO } from './const';

const initState = {
  expandId: {},
};
interface IAction {
  type: string;
  payload: {
    expandId: string;
  };
}

const reducer = (state = initState, { type, payload }: IAction) => {
  switch (type) {
    case SET_CATEGORY_INFO:
      return {
        ...state,
        expandId: payload.expandId,
      };
  }
  return state;
};

export default reducer;
